import { duration, toast } from '@/common/util';
import baseApi from './base.api';
import BaseService from './base.service';
// Conversor de certficado v1 para v2
export const versionUpgrade = (original) => {
    const structure = typeof original === 'string' ? JSON.parse(original) : original;
    if (Number(structure?.v) > 1)
        return structure;
    // @TODO: Checar se a estrutura abaixo é valida, aparentemente todos os "v1" tem as mesmas dimensões
    // const orientation = structure.settings?.page?.orientation || 'landscape'
    // let pageWidth = orientation === 'landscape' && structure.settings?.page?.width > structure.settings?.page?.height
    //   ? structure.settings?.page?.width
    //   : structure.settings?.page?.height
    // let pageHeight = orientation === 'landscape' && structure.settings?.page?.width > structure.settings?.page?.height
    //   ? structure.settings?.page?.height
    //   : structure.settings?.page?.width
    // pageWidth = (pageWidth || orientation === 'landscape' ? 297 : 210) * 3
    // pageHeight = (pageHeight || orientation === 'landscape' ? 210 : 297) * 3
    let pageWidth = 1122;
    let pageHeight = 793;
    const result = {
        ...structure,
        settings: {
            ...structure.settings,
            page: {
                ...structure.settings?.page || {},
                width: pageWidth,
                height: pageHeight
            }
        },
        background: {
            color: structure.background?.color || '#ffffff',
            img: {
                mirrorX: structure.background?.mirrorX || false,
                mirrorY: structure.background?.mirrorY || false,
                url: structure.background?.img?.url || null,
                opacity: (structure.background?.opacity || 255) / 255
            }
        },
        layers: structure.layers.map((layer) => {
            const tp = layer.text?.content ? 'text' : layer.img?.url ? 'image' : 'object';
            const rect = {
                x: (pageWidth * layer.rect.x) / 100,
                y: (pageHeight * layer.rect.y) / 100,
                w: (pageWidth * layer.rect.w) / 100,
                h: (pageHeight * layer.rect.h) / 100,
                scaleX: layer.rect?.scaleX || 1,
                scaleY: layer.rect?.scaleY || 1
            };
            if (tp === 'image') {
                if (layer?.rect?.w)
                    rect.scaleX = layer.rect.w / 100;
                if (layer?.rect?.h)
                    rect.scaleY = layer.rect.h / 100;
            }
            if (tp === 'text') {
                return {
                    type: 'text',
                    rect,
                    text: {
                        content: layer.text.content,
                        fontSize: layer.text.size || 20,
                        textAlign: layer.text?.align || 'left',
                        fontFamily: layer.text?.fontFamily
                    }
                };
            }
            // @TODO: Checar opacidade
            if (tp === 'image') {
                return {
                    type: 'image',
                    rect,
                    img: {
                        id: layer.img.id,
                        url: layer.img.url || null
                    }
                };
            }
            return {};
        })
    };
    if (structure?.settings?.page?.backSide) {
        result['backLayers'] = [
            {
                type: 'object',
                rect: {
                    x: 980,
                    y: 20,
                    w: 80,
                    h: 80,
                    scaleX: 0.6,
                    scaleY: 0.6
                },
                object: {
                    type: 'qrcode'
                },
                order: 0
            },
            {
                type: 'text',
                rect: {
                    x: 32,
                    y: 23,
                    w: 464,
                    h: 40
                },
                text: {
                    content: 'Contéudo Progamático',
                    fontSize: 24,
                    fontWeight: 'bold'
                },
                order: 1
            },
            {
                type: 'text',
                rect: {
                    x: 34,
                    y: 68,
                    w: 420,
                    h: 28
                },
                text: {
                    content: "#CONTENT#",
                    fontSize: 18,
                    lineHeight: 1.2
                },
                order: 2
            }
        ];
    }
    return result;
};
export const certificateService = {
    ...baseApi,
    resource: 'certificado',
    getById: (id) => {
        return certificateService.get(id)
            .then(({ success, data }) => ({
            success,
            data: {
                id: data.id,
                name: data.nome,
                type: data.tipo === 'Curso' ? 'course' : 'trail',
                active: data.active,
                createdAt: data.createdAt,
                structure: versionUpgrade(data.jsonCertificado)
            }
        }));
    },
    save: (localData) => {
        //Usa dicionário para converter os dados "local" para "remoto"
        const normalized = {
            nome: localData.name,
            tipo: localData.type === 'course' ? 'Curso' : 'Formacao',
            jsonCertificado: JSON.stringify(localData.structure)
        };
        const postDataRemote = new FormData();
        const keys = Object.keys(normalized);
        for (let i = 0; i < keys.length; i++)
            postDataRemote.append(keys[i], normalized[keys[i]]);
        const headers = { 'Content-Type': 'multipart/form-data' };
        if (localData.structure?.v === 2) {
            // @ts-ignore
            postDataRemote.append('imprimeVerso', localData.structure?.settings?.page?.backSide ? true : false);
        }
        // Se for novo certificado, remove o atributo id
        if (!localData.id) {
            return certificateService.post('', postDataRemote, { headers });
        }
        return certificateService.put(localData.id, postDataRemote, { headers });
    },
    getCertData(id, courseOrTrailId) {
        return certificateService
            .get(`Imprimir/${id}/${courseOrTrailId}`)
            .then(({ success, data }) => ({
            success,
            data: {
                ...data,
                course: data.curso?.itensDoCurso?.map(item => ({
                    name: item.midia?.nome || item.avaliacao?.titulo,
                    duration: item.midia?.duracao || null,
                    type: item.tipo
                })) || [],
                trail: data.formacao?.etapas?.map(step => ({
                    name: step.nome,
                    duration: step?.duracao,
                    items: step?.itens?.map(item => ({
                        name: item.nome,
                        duration: item?.duracao,
                        type: item.tipo,
                        items: item?.itens?.map(subItem => ({
                            name: subItem.nome,
                            duration: subItem.duracao
                        })) || []
                    })) || []
                })) || []
            }
        }));
    },
    /**
     * Valida o código do certificado (credencial)
     */
    validateCredential(code) {
        return certificateService
            .get(`validate/${code}/credential`)
            .then(({ success, data }) => {
            if (!success)
                return;
            const replaceData = {
                '#TITULO#': data.curso?.titulo || data.formacao?.titulo || '',
                '#NOME#': data.usuarioNome || '',
                '#CPF#': data.usuarioCpf || '',
                '#CARGO#': data.cargoNome || '',
                '#DT_CONCLUSAO#': data.dataEmissao ? new Date(data.dataEmissao).toLocaleDateString() : null,
                '#CARGA_HORARIA#': data.cargaHoraria ? duration(data.cargaHoraria) : 0,
                '#DT_INSCRICAO#': (data.curso?.dataInscricao || data.formacao?.dataInscricao)
                    ? new Date(data.curso?.dataInscricao || data.formacao?.dataInscricao).toLocaleDateString()
                    : null,
                '#CREDENCIAL#': data?.credencial || ''
            };
            const structure = versionUpgrade(data.certificado.jsonCertificado);
            // Substitui os textos de cada layer de tipo 'text'
            structure.layers = structure.layers.map((layer) => {
                if (layer.type !== 'text')
                    return layer;
                let replacedText = layer.text.content;
                for (const tag in replaceData) {
                    if (Object.prototype.hasOwnProperty.call(replaceData, tag)) {
                        const regExp = new RegExp(tag, 'gi');
                        replacedText = replacedText.replace(regExp, (match) => {
                            const value = replaceData[tag]?.toString() || '';
                            // Se a tag encontrada no template estiver toda em maiúsculas, converte o valor para maiúsculas
                            if (match === match.toUpperCase())
                                return value.toUpperCase();
                            return value;
                        });
                    }
                }
                return {
                    ...layer,
                    text: {
                        ...layer.text,
                        content: replacedText
                    }
                };
            });
            // Substitui as camadas do tipo 'qrcode' pelo link de validação
            structure.layers = structure.layers.map((layer) => {
                if (layer.type !== 'object' || layer.object?.type !== 'qrcode')
                    return layer;
                return {
                    ...layer,
                    object: {
                        ...layer.object,
                        url: data.linkValidacao
                    }
                };
            });
            return structure;
        })
            .catch((err) => {
            if (err?.status === 404) {
                toast.error({
                    title: 'Página não encontrada',
                    message: 'O método de validação de certificados não foi encontrado. Por favor, entre em contato com o suporte.'
                });
                return null;
            }
        });
    },
    printUserCertificate(certificadoId, cursoFormacaoId, usuarioId) {
        return certificateService
            .get(`Imprimir/${certificadoId}/${cursoFormacaoId}/${usuarioId}`)
            .then(({ success, data }) => ({
            success,
            data: {
                ...data,
                course: data.curso?.itensDoCurso?.map(item => ({
                    name: item.midia?.nome || item.avaliacao?.titulo,
                    duration: item.midia?.duracao || null,
                    type: item.tipo
                })) || [],
                trail: data.formacao?.etapas?.map(step => ({
                    name: step.nome,
                    duration: step?.duracao,
                    items: step?.itens?.map(item => ({
                        name: item.nome,
                        duration: item?.duracao,
                        type: item.tipo,
                        items: item?.itens?.map(subItem => ({
                            name: subItem.nome,
                            duration: subItem.duracao
                        })) || []
                    })) || []
                })) || []
            }
        }));
    },
};
class CertificadosService extends BaseService {
    constructor() {
        super({ resource: 'certificado' });
    }
    async getCertData(certificadoId, cursoFormacaoId, usuarioId) {
        return this.plantarApi.get(`${this.resource}/Imprimir/${certificadoId}/${cursoFormacaoId}/${usuarioId}`);
    }
    async imprimir(certificadoId, cursoFormacaoId) {
        return certificateService.getCertData(certificadoId, cursoFormacaoId);
    }
    async imprimirCertificadoUsuario(certificadoId, cursoFormacaoId, usuarioId) {
        return certificateService.printUserCertificate(certificadoId, cursoFormacaoId, usuarioId);
    }
    async upload(obj) {
        const postData = new FormData();
        const keys = Object.keys(obj.data);
        for (let i = 0; i < keys.length; i++) {
            postData.append(keys[i], obj.data[keys[i]]);
        }
        try {
            const { data, success } = await this.plantarApi.post(`${this.resource}/FileUpload/${obj.certificadoId}/${obj.alias}`, postData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return { data, success, notifications: [] };
        }
        catch (error) {
            const { notifications, success } = error.response?.data || {};
            return {
                data: {},
                success,
                notifications
            };
        }
    }
}
const certificadosService = new CertificadosService();
export default certificadosService;
